class UserRightDto {

    Screen: number;
    UserRight: number;
    Childrens: UserRightDto[];

    constructor(screen: number, userRight: number, childrens: UserRightDto[]) {
        this.Screen = screen;
        this.UserRight = userRight;
        this.Childrens = childrens;
    }

    GetUserRight(screen: number) : number {
        if (screen === this.Screen) {
            return this.UserRight;
        }
        else {
            return this.Childrens.find(e => e.Screen === screen)?.UserRight ?? 0;  
        }
    }
}

export default UserRightDto;